export default __webpack_public_path__ + "static/plant-conveyor-e16fd24f886bea86212161a16a52ba46.jpeg";